import LZString from "lz-string";

export const stringDecompression = (data) => {
    return LZString.decompressFromEncodedURIComponent(data)
}